import { AfterViewInit, Component, Input, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ISimpleListConfig } from '../simple-list';
import { BaseComponent } from '../base.component';
import { IJumpToMenuConfig } from './ijump-to-menu-config.interface';
import { ILoadableComponent } from '@nha/services';
import { TemplateFunctionPipe } from '../../pipes/template-function.pipe';
import { RouterLink } from '@angular/router';
import { NHASimpleListComponent } from '../simple-list/simple-list.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NHATestDirective } from '../../directives/test/test.directive';
import { NHAPopupComponent } from '../popup/popup.component';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';

@Component({
    selector: 'nha-jump-to-menu',
    templateUrl: './jump-to-menu.component.html',
    styleUrls: ['./jump-to-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
    NHAPopupComponent,
    NHATestDirective,
    MatButtonModule,
    MatIconModule,
    NHASimpleListComponent,
    RouterLink,
    NgTemplateOutlet,
    AsyncPipe,
    TemplateFunctionPipe
]
})
export class NHAJumpToMenuComponent extends BaseComponent implements AfterViewInit, ILoadableComponent {
	@ViewChild('itemInfoTemplate', { read: TemplateRef })
	private _itemInfoTemplate: TemplateRef<unknown>;

	@Input() selectedItem: unknown;
	@Input() items: unknown[] = [];
	@Input() jumpToMenuConfig: IJumpToMenuConfig;

	public menuListConfig: ISimpleListConfig;

	constructor() {
		super();
	}

	ngAfterViewInit(): void {
		this.menuListConfig = {
			html: this.jumpToMenuConfig.html,
			link: this.jumpToMenuConfig.link,
			linkIsExternal: this.jumpToMenuConfig.linkIsExternal,
			searchFunc: this.jumpToMenuConfig.search,
			placeholder: this.jumpToMenuConfig.searchPlaceholder,
			action: this.closePopUp.bind(this),
			itemPadLeft: '0px',
			customTemplate: this.jumpToMenuConfig.customMenuItemTemplate ?? this._itemInfoTemplate,
			displaySearchBarCount: 0
		};

		super.ngAfterViewInit();
	}

	closePopUp(): void {
		const cdkOverlayContainer = document.getElementsByClassName(
			'cdk-overlay-backdrop mat-overlay-transparent-backdrop cdk-overlay-backdrop-showing'
		)[0] as HTMLElement;

		if (cdkOverlayContainer) {
			cdkOverlayContainer.click();
		}
	}
}
